import React from 'react'

const CompanyPayroll = () => {
  return (
    <div>CompanyPayroll</div>
  )
}

export default CompanyPayroll